/* Core & libraries */
import React, { useState, useRef, useEffect } from "react";
import { useTheme } from "react-jss";
import {defineMessages, FormattedMessage, useIntl} from "react-intl";
import {ErrorMessage, Field, Formik, getIn} from "formik";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import UCButton from "../../buttons";

/* Helpers, constants, custom methods, internal libraries */
import {
  createValidationPolicyYupSchema,
  useValidationService
} from "../../../resources/validations/validations";

/* Components */

/* Styles */
import styles from "./styles.js"
import {colors} from "../../../constants/colors";


const messages = defineMessages({
  teamNamePlaceholderMessage: {
    id: 'createTeam.teamName'
  },
  ariaLabelCreateTeam: {
    id: 'createTeam.ariaLabelCreateTeam'
  }
})

const Content = props => {
  const { setShowModal, handleCreateTeam, companyEntityId, teamNameError, setTeamNameError } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  const formRef = useRef(null);
  const intl = useIntl();

  const { createTeamMockedValidationObj } = useValidationService()
  const [testSchema, setTestSchema] = useState({});
  const [previousTeam, setPreviousTeam] = useState("");

  useEffect(() => {
    //TODO: api call to get validations //simpleMockedApiValidationObj
    const result = createValidationPolicyYupSchema(createTeamMockedValidationObj);
    setTestSchema(result)
  }, [])

  const handleFormSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit()
    }
  }

  const checkInputValue = (values) => {
    if(teamNameError) {
      if(values.groupName !== previousTeam) {
        setTeamNameError(false)
      }
    }
  }

  const submitForm = (values, setSubmitting) => {
    handleCreateTeam(values, setPreviousTeam)
    setSubmitting(false);
  }

  return (
    <div className={classes.modalContent}>
      <Formik
        innerRef={formRef}
        initialValues={{
          companyEntityId: companyEntityId,
          groupName:"",
        }}
        validationSchema={testSchema}
        onSubmit={(values, { setSubmitting }) => {
          submitForm(values, setSubmitting);
        }}
      >
        {({
          values,
          errors,
          touched,
          setFieldTouched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
            setFieldValue
          }) => (

          <>
            <form onSubmit={handleSubmit} onChange={checkInputValue(values)}>
              <div className={classes.inputContainer}>
                <label htmlFor="groupName" className={classes.label}>
                  <FormattedMessage id="createTeam.name"/>
                </label>
                <Field
                  placeholder={intl.formatMessage(messages.teamNamePlaceholderMessage)}
                  type="text"
                  name="groupName"
                  id="groupName"
                  className={
                    errors.groupName && touched.groupName
                      ? "input-error" 
                      : teamNameError 
                      ? "input-error"
                      : null
                  }
                  aria-label={intl.formatMessage(messages.ariaLabelCreateTeam)}
                  aria-invalid={errors.groupName && touched.groupName ? 'true' : null}
                  aria-describedby={errors.groupName && touched.groupName ? 'create-team-error' : null}
                />
              
                {
                  teamNameError ? 
                    <div className={classes.nameError} id="create-team-error" role="alert" aria-live="assertive">
                      <FormattedMessage id="createTeam.teamNameError" />
                    </div>
                  : 
                    <ErrorMessage
                      name="groupName"
                      component="span"
                      className={classes.error}
                      id="create-team-error"
                      role="alert"
                      aria-live="assertive"
                    />
                }
              </div>
              <div className={classes.btnContainer}>
                <ContainerFluid>
                  <Row>
                    <Col className={classes.colCancel}>
                      <UCButton
                        onClick={() => setShowModal(false)}
                        type="default"
                        className={classes.cancelBtn}
                        text={<FormattedMessage id="createTeam.cancel"/>}
                        tabIndex={0}
                      />
                    </Col>
                    <Col className={classes.colRemove} >
                      <UCButton
                        className={classes.createBtn}
                        onClick={handleFormSubmit}
                        type="primary"
                        text={<FormattedMessage id="createTeam.createTeam"/>}
                        spinner={{
                          name: "createTeamSpinner",
                          size: 20,
                        }}
                        tabIndex={0}
                      />
                    </Col>
                  </Row>
                </ContainerFluid>
              </div>
            </form>
          </>
        )}
      </Formik>
    </div>
  )
}

export default Content;
